import Utils from "../../../../../../shared/utils";

export const HEADER_IMAGE = Utils.buildMortPersonalAreaImgLink("drawer/header.svg")
export const BACK_CHEVRON = Utils.buildMortPersonalAreaImgLink("icons/chevron-right.svg")